import React from "react";
import { Container } from "@ui";
import BrightEdgeContent from "./BrightEdgeContent";

interface BrightEdgeSectionProps {
  bodyCapsuleData: string;
}

const BrightEdgeSection = ({ bodyCapsuleData }: BrightEdgeSectionProps) => {
  return (
    <section className="bg-lightBlue py-12 lg:py-16 ">
      <Container>
        <BrightEdgeContent htmlContent={bodyCapsuleData} />
      </Container>
    </section>
  );
};

export default BrightEdgeSection;
